module.exports = __webpack_public_path__ + "img/ctxc.27d95af6.svg";